import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Image } from 'react-bootstrap';
import { FaAngleDown } from 'react-icons/fa6';

import 'bootstrap/dist/css/bootstrap.min.css';
import '../../../../SignUp/onBoarding/located.css';

import location from "../../../../../assets/images/location.png";
import { showAlert } from "../../../../../utils/alertUtils";
import { useCookies } from '../../../../../hooks/useCookies';
import Sidebar from '../../../../userflow/components/sidebar/sidebar';
import { useProfile } from "../../../../userflow/components/context/ProfileContext";

import * as userActions from "../../../../../actions/user";
import * as masterConstantActions from "../../../../../actions/masterConstant";

export default function HeightUpdate() {
    const isFetched = useRef(false);
    const navigate = useNavigate();
    const { getCookie } = useCookies();
    const { updateProfile } = useProfile();

    const [selectedHeight, setSelectedHeight] = useState({});
    const [heights, setHeights] = useState([]);
    const locationSelectRef = useRef(null);
    const approvalstatus = getCookie("approval");

    const fetchUserGrowthsOptions = async () => {
        try {
            const response = await masterConstantActions.getConstantGrowths();
            if (response.status && response.data.length > 0) {
                setHeights(response.data);
            }
        } catch (error) {
            console.error("Error fetching growth options:", error);
        }
    };

    const fetchUserGrowths = async () => {
        try {
            const response = await userActions.getUserGrowths();
            setSelectedHeight(response?.growths?.[0]);
        } catch (error) {
            console.error("Error fetching growths:", error);
        }
    };

    useEffect(() => {
        if (isFetched.current) return;
        isFetched.current = true;
        fetchUserGrowthsOptions();
        fetchUserGrowths();
    }, []);

    const handleHeightSelect = (height) => {
        setSelectedHeight(height);
    };

    const handleSubmit = async (e) => {
      e.preventDefault();
      if (!selectedHeight.id) {
        showAlert("Error", "Please select your height.");
        return;
      }

      try {
        await userActions.UpdateUserGrowths({ growthId: selectedHeight.id });
        await updateProfile("update");

        if (approvalstatus === "PENDING") {
          showAlert("Success", "Approval request sent!", () =>
            navigate("/user/home")
          );
        } else {
          showAlert("Success", "Successfully updated", () =>
            navigate("/updateprofile")
          );
        }
      } catch (error) {
        showAlert("Error", "Failed to update height.");
        console.error("Error updating height:", error);
      }
    };

    return (
        <Sidebar>
            <div style={{
                flex: "1",
                marginInline: "auto",
                display: "flex",
                flexDirection: "column",
                gap: "1rem",
                overflowY: "auto",

                padding: "2rem"
            }}>

                <div className='located-container' style={{ overflow: 'hidden' }}>
                    <Container className='located-main'>
                        <Container className='located-content' style={{ width: "100%" }}>
                            <Container className='located-text'>
                                <Image className='about-yourself-icon' src={location} alt="Location" />
                                <p>How tall are you?</p>
                            </Container>

                            <Container className='located-details'>
                                <Container
                                    ref={locationSelectRef}
                                    className='located-country collasped'
                                    style={{ overflow: 'hidden', "--select-options-container-height": '20rem' }}
                                >
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                        }}
                                        className="select-input-wrapper"
                                        onClick={() => {
                                            locationSelectRef.current.classList.toggle('collasped');
                                        }}
                                    >
                                        <input
                                            type="text"
                                            value={selectedHeight?.name || ""}
                                            readOnly
                                            placeholder="Select height"
                                            style={{
                                                paddingInline: '0.5rem',
                                                paddingBlock: '0.75rem',
                                                width: '100%',
                                                border: "none",
                                                fontSize: "large"
                                            }}
                                        />
                                        <FaAngleDown size={16} style={{ marginRight: "1rem" }} />
                                    </div>

                                    <div
                                        className='scroll-container-vertical'
                                        style={{ height: '13rem', maxHeight: '13rem' }}
                                    >
                                        {heights.map((height) => (
                                            <div
                                                key={height.id}
                                                className={`scroll-item ${selectedHeight?.id === height.id ? 'selected' : ''}`}
                                                onClick={() => {
                                                    handleHeightSelect(height);
                                                    locationSelectRef.current.classList.add("collasped");
                                                }}
                                            >
                                                {height.name}
                                            </div>
                                        ))}
                                    </div>
                                </Container>
                            </Container>

                            <div className="d-flex justify-content-center action-buttons">
                                <button className="global-cancel-button" onClick={() => navigate("/updateprofile")}>
                                    Cancel
                                </button>
                                <button onClick={handleSubmit} type="submit" className="global-save-button">
                                    Save
                                </button>
                            </div>
                        </Container>
                    </Container>
                </div>
            </div>
        </Sidebar>
    );
}
